import React from 'react';
import { Coffee, CreditCard, Monitor, Settings, TrendingUp, Users, Clock, CheckCircle2, Wallet, Slash } from 'lucide-react';

export const Solution = () => {
  const features = [
    {
      icon: Coffee,
      title: 'Café, bebidas y snacks disponibles',
      description: 'Variedad durante todo el día.'
    },
    {
      icon: CreditCard,
      title: 'Pagos digitales',
      description: 'Acepta tarjeta, Yape, Plin y pagos sin contacto.'
    },
    {
      icon: Monitor,
      title: 'Pantalla inteligente',
      description: 'Ideal para mostrar comunicados o campañas.'
    },
    {
      icon: Settings,
      title: 'Operación 100% gestionada',
      description: 'BOCADIA se encarga de abastecimiento y mantenimiento.'
    }
  ];

  const benefits = [
    {
      icon: TrendingUp,
      text: 'Mejora la experiencia de usuarios y visitantes'
    },
    {
      icon: Clock,
      text: 'Facilita pausas durante la jornada'
    },
    {
      icon: Users,
      text: 'Aumenta la comodidad en espacios comunes'
    },
    {
      icon: CheckCircle2,
      text: 'No requiere inversión ni gestión administrativa'
    }
  ];

  return (
    <section id="solucion" className="py-12 md:py-16 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #003847 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-[#CFAE70]/10 text-[#CFAE70] text-sm font-semibold rounded-full mb-6">
              Nuestra Solución
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#003847] mb-6">
              Todo lo que necesitas en un solo punto
            </h2>

            {/* Features */}
            <div className="space-y-6 mb-12">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={index}
                    className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#F8F5F0] transition-all duration-300 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-[#003847] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-[#003847] mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_7af41d00-b48b-48e6-a9ac-e766c800b011/artifacts/mhpwb7xr_imagen%202%20solucion.png"
                alt="BOCADIA Smart Vending Machine"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#003847]/20 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white p-3 md:p-6 rounded-xl md:rounded-2xl shadow-2xl">
              <div className="flex items-center gap-2 md:gap-4">
                <div className="w-10 h-10 md:w-16 md:h-16 bg-[#CFAE70] rounded-lg md:rounded-xl flex items-center justify-center relative">
                  <Wallet className="w-5 h-5 md:w-8 md:h-8 text-white" />
                  <Slash className="w-6 h-6 md:w-10 md:h-10 text-white absolute" style={{ strokeWidth: 3 }} />
                </div>
                <div>
                  <p className="text-sm md:text-xl font-bold text-[#003847]">Sin inversión</p>
                  <p className="text-xs md:text-sm text-gray-600">para tu espacio</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
